import React, { forwardRef, useImperativeHandle, useState } from "react";
import { ButtonBase } from "../styles/base";
import ImageGalleryModal from "./image-gallery-modal";

const ImageGallery = forwardRef(({ children, className, renderImagesOverlay }, ref) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [initialIndex, setInitialIndex] = useState(null);

  useImperativeHandle(ref, () => ({
    open: (index) => {
      setInitialIndex(index);
      setModalIsOpen(true);
    },
  }));

  const handleImageClick = (index) => {
    setInitialIndex(index);
    setModalIsOpen(true);
  };

  const handleCloseModal = () => {
    setInitialIndex(null);
    setModalIsOpen(false);
  };

  return (
    <>
      {React.Children.map(children, (child, index) => {
        if (child?.props?.hidden) {
          return null;
        }
        return (
          <ButtonBase
            className={className}
            css={`
                cursor: ${child?.props?.disabled ? "wait" : "zoom-in"}!important;
              `}
            disabled={child?.props?.disabled}
            onClick={() => handleImageClick(index)}
            type="button"
          >
            {React.cloneElement(child)}
          </ButtonBase>
        );
      })}
      {modalIsOpen && (
        <ImageGalleryModal
          initialIndex={initialIndex}
          isOpen={modalIsOpen}
          onClose={handleCloseModal}
          renderImagesOverlay={renderImagesOverlay}
        >
          {children}
        </ImageGalleryModal>
      )}
    </>
  );
});

export default ImageGallery;
